/**
 * Options REST API
 *
 * Access market data, manage accounts, and trade Binance Options.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {
    ConfigurationRestAPI,
    TimeUnit,
    RestApiResponse,
    assertParamExists,
    sendRequest,
    type RequestArgs,
} from '@binance/common';
import type {
    AcceptBlockTradeOrderResponse,
    AccountBlockTradeListResponse,
    ExtendBlockTradeOrderResponse,
    NewBlockTradeOrderLegsParameterInner,
    NewBlockTradeOrderResponse,
    QueryBlockTradeDetailsResponse,
    QueryBlockTradeOrderResponse,
} from '../types';

/**
 * MarketMakerBlockTradeApi - axios parameter creator
 */
const MarketMakerBlockTradeApiAxiosParamCreator = function (configuration: ConfigurationRestAPI) {
    return {
        /**
         * Accept a block trade order
         *
         * Weight(IP): 5
         *
         * Security Type: TRADE
         *
         * @summary Accept Block Trade Order (TRADE)
         * @param {string} blockOrderMatchingKey
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        acceptBlockTradeOrder: async (
            blockOrderMatchingKey: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockOrderMatchingKey' is not null or undefined
            assertParamExists(
                'acceptBlockTradeOrder',
                'blockOrderMatchingKey',
                blockOrderMatchingKey
            );

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (blockOrderMatchingKey !== undefined && blockOrderMatchingKey !== null) {
                localVarQueryParameter['blockOrderMatchingKey'] = blockOrderMatchingKey;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/order/execute',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Gets block trades for a specific account.
         *
         * Weight(IP): 5
         *
         * Security Type: USER_DATA
         *
         * @summary Account Block Trade List (USER_DATA)
         * @param {number | bigint} [endTime] End Time, e.g 1593512200000
         * @param {number | bigint} [startTime] Start Time, e.g 1593511200000
         * @param {string} [underlying] Underlying asset.
         * @param {number | bigint} [recvWindow] Recv Window.
         *
         * @throws {RequiredError}
         */
        accountBlockTradeList: async (
            endTime?: number | bigint,
            startTime?: number | bigint,
            underlying?: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (underlying !== undefined && underlying !== null) {
                localVarQueryParameter['underlying'] = underlying;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/user-trades',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Cancel a block trade order.
         *
         * Weight(IP): 5
         *
         * Security Type: TRADE
         *
         * @summary Cancel Block Trade Order (TRADE)
         * @param {string} blockOrderMatchingKey Block trade matching key.
         * @param {number | bigint} [recvWindow] Recv Window.
         *
         * @throws {RequiredError}
         */
        cancelBlockTradeOrder: async (
            blockOrderMatchingKey: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockOrderMatchingKey' is not null or undefined
            assertParamExists(
                'cancelBlockTradeOrder',
                'blockOrderMatchingKey',
                blockOrderMatchingKey
            );

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (blockOrderMatchingKey !== undefined && blockOrderMatchingKey !== null) {
                localVarQueryParameter['blockOrderMatchingKey'] = blockOrderMatchingKey;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/order/create',
                method: 'DELETE',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Extends a block trade expire time by 30 mins from the current time.
         *
         * Weight(IP): 5
         *
         * Security Type: TRADE
         *
         * @summary Extend Block Trade Order (TRADE)
         * @param {string} blockOrderMatchingKey
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        extendBlockTradeOrder: async (
            blockOrderMatchingKey: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockOrderMatchingKey' is not null or undefined
            assertParamExists(
                'extendBlockTradeOrder',
                'blockOrderMatchingKey',
                blockOrderMatchingKey
            );

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (blockOrderMatchingKey !== undefined && blockOrderMatchingKey !== null) {
                localVarQueryParameter['blockOrderMatchingKey'] = blockOrderMatchingKey;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/order/create',
                method: 'PUT',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Send in a new block trade order.
         *
         * Weight(IP): 5
         *
         * Security Type: TRADE
         *
         * @summary New Block Trade Order (TRADE)
         * @param {NewBlockTradeOrderLiquidityEnum} liquidity
         * @param {Array<NewBlockTradeOrderLegsParameterInner>} legs Max 1 (only single leg supported), list of legs parameters in JSON; example: eapi/v1/block/order/create?orders=[{"symbol":"BTC-210115-35000-C", "price":"100","quantity":"0.0002","side":"BUY","type":"LIMIT"}]
         * @param {number | bigint} [recvWindow]
         *
         * @throws {RequiredError}
         */
        newBlockTradeOrder: async (
            liquidity: NewBlockTradeOrderLiquidityEnum,
            legs: Array<NewBlockTradeOrderLegsParameterInner>,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'liquidity' is not null or undefined
            assertParamExists('newBlockTradeOrder', 'liquidity', liquidity);
            // verify required parameter 'legs' is not null or undefined
            assertParamExists('newBlockTradeOrder', 'legs', legs);

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (liquidity !== undefined && liquidity !== null) {
                localVarQueryParameter['liquidity'] = liquidity;
            }
            if (legs) {
                localVarQueryParameter['legs'] = legs;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/order/create',
                method: 'POST',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Query block trade details; returns block trade details from counterparty's perspective.
         *
         * Weight(IP): 5
         *
         * Security Type: USER_DATA
         *
         * @summary Query Block Trade Details (USER_DATA)
         * @param {string} blockOrderMatchingKey Block trade matching key.
         * @param {number | bigint} [recvWindow] Recv Window.
         *
         * @throws {RequiredError}
         */
        queryBlockTradeDetails: async (
            blockOrderMatchingKey: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            // verify required parameter 'blockOrderMatchingKey' is not null or undefined
            assertParamExists(
                'queryBlockTradeDetails',
                'blockOrderMatchingKey',
                blockOrderMatchingKey
            );

            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (blockOrderMatchingKey !== undefined && blockOrderMatchingKey !== null) {
                localVarQueryParameter['blockOrderMatchingKey'] = blockOrderMatchingKey;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/order/execute',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
        /**
         * Check block trade order status.
         *
         * Weight(IP): 5
         *
         * Security Type: TRADE
         *
         * @summary Query Block Trade Order (TRADE)
         * @param {string} [blockOrderMatchingKey] If specified, returns the specific block trade associated with the blockOrderMatchingKey
         * @param {number | bigint} [endTime] End Time, e.g 1593512200000
         * @param {number | bigint} [startTime] Start Time, e.g 1593511200000
         * @param {string} [underlying] Underlying asset.
         * @param {number | bigint} [recvWindow] Recv Window.
         *
         * @throws {RequiredError}
         */
        queryBlockTradeOrder: async (
            blockOrderMatchingKey?: string,
            endTime?: number | bigint,
            startTime?: number | bigint,
            underlying?: string,
            recvWindow?: number | bigint
        ): Promise<RequestArgs> => {
            const localVarQueryParameter: Record<string, unknown> = {};
            const localVarBodyParameter: Record<string, unknown> = {};
            const localVarHeaderParameter: Record<string, unknown> = {};

            if (blockOrderMatchingKey !== undefined && blockOrderMatchingKey !== null) {
                localVarQueryParameter['blockOrderMatchingKey'] = blockOrderMatchingKey;
            }
            if (endTime !== undefined && endTime !== null) {
                localVarQueryParameter['endTime'] = endTime;
            }
            if (startTime !== undefined && startTime !== null) {
                localVarQueryParameter['startTime'] = startTime;
            }
            if (underlying !== undefined && underlying !== null) {
                localVarQueryParameter['underlying'] = underlying;
            }
            if (recvWindow !== undefined && recvWindow !== null) {
                localVarQueryParameter['recvWindow'] = recvWindow;
            }

            let _timeUnit: TimeUnit | undefined;
            if ('timeUnit' in configuration) _timeUnit = configuration.timeUnit as TimeUnit;

            return {
                endpoint: '/eapi/v1/block/order/orders',
                method: 'GET',
                queryParams: localVarQueryParameter,
                bodyParams: localVarBodyParameter,
                headerParams: localVarHeaderParameter,
                timeUnit: _timeUnit,
            };
        },
    };
};

/**
 * MarketMakerBlockTradeApi - interface
 * @interface MarketMakerBlockTradeApi
 */
export interface MarketMakerBlockTradeApiInterface {
    /**
     * Accept a block trade order
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Accept Block Trade Order (TRADE)
     * @param {AcceptBlockTradeOrderRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    acceptBlockTradeOrder(
        requestParameters: AcceptBlockTradeOrderRequest
    ): Promise<RestApiResponse<AcceptBlockTradeOrderResponse>>;
    /**
     * Gets block trades for a specific account.
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Account Block Trade List (USER_DATA)
     * @param {AccountBlockTradeListRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    accountBlockTradeList(
        requestParameters?: AccountBlockTradeListRequest
    ): Promise<RestApiResponse<AccountBlockTradeListResponse>>;
    /**
     * Cancel a block trade order.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Cancel Block Trade Order (TRADE)
     * @param {CancelBlockTradeOrderRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    cancelBlockTradeOrder(
        requestParameters: CancelBlockTradeOrderRequest
    ): Promise<RestApiResponse<void>>;
    /**
     * Extends a block trade expire time by 30 mins from the current time.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Extend Block Trade Order (TRADE)
     * @param {ExtendBlockTradeOrderRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    extendBlockTradeOrder(
        requestParameters: ExtendBlockTradeOrderRequest
    ): Promise<RestApiResponse<ExtendBlockTradeOrderResponse>>;
    /**
     * Send in a new block trade order.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary New Block Trade Order (TRADE)
     * @param {NewBlockTradeOrderRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    newBlockTradeOrder(
        requestParameters: NewBlockTradeOrderRequest
    ): Promise<RestApiResponse<NewBlockTradeOrderResponse>>;
    /**
     * Query block trade details; returns block trade details from counterparty's perspective.
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Query Block Trade Details (USER_DATA)
     * @param {QueryBlockTradeDetailsRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    queryBlockTradeDetails(
        requestParameters: QueryBlockTradeDetailsRequest
    ): Promise<RestApiResponse<QueryBlockTradeDetailsResponse>>;
    /**
     * Check block trade order status.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Query Block Trade Order (TRADE)
     * @param {QueryBlockTradeOrderRequest} requestParameters Request parameters.
     *
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApiInterface
     */
    queryBlockTradeOrder(
        requestParameters?: QueryBlockTradeOrderRequest
    ): Promise<RestApiResponse<QueryBlockTradeOrderResponse>>;
}

/**
 * Request parameters for acceptBlockTradeOrder operation in MarketMakerBlockTradeApi.
 * @interface AcceptBlockTradeOrderRequest
 */
export interface AcceptBlockTradeOrderRequest {
    /**
     *
     * @type {string}
     * @memberof MarketMakerBlockTradeApiAcceptBlockTradeOrder
     */
    readonly blockOrderMatchingKey: string;

    /**
     *
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiAcceptBlockTradeOrder
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for accountBlockTradeList operation in MarketMakerBlockTradeApi.
 * @interface AccountBlockTradeListRequest
 */
export interface AccountBlockTradeListRequest {
    /**
     * End Time, e.g 1593512200000
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiAccountBlockTradeList
     */
    readonly endTime?: number | bigint;

    /**
     * Start Time, e.g 1593511200000
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiAccountBlockTradeList
     */
    readonly startTime?: number | bigint;

    /**
     * Underlying asset.
     * @type {string}
     * @memberof MarketMakerBlockTradeApiAccountBlockTradeList
     */
    readonly underlying?: string;

    /**
     * Recv Window.
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiAccountBlockTradeList
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for cancelBlockTradeOrder operation in MarketMakerBlockTradeApi.
 * @interface CancelBlockTradeOrderRequest
 */
export interface CancelBlockTradeOrderRequest {
    /**
     * Block trade matching key.
     * @type {string}
     * @memberof MarketMakerBlockTradeApiCancelBlockTradeOrder
     */
    readonly blockOrderMatchingKey: string;

    /**
     * Recv Window.
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiCancelBlockTradeOrder
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for extendBlockTradeOrder operation in MarketMakerBlockTradeApi.
 * @interface ExtendBlockTradeOrderRequest
 */
export interface ExtendBlockTradeOrderRequest {
    /**
     *
     * @type {string}
     * @memberof MarketMakerBlockTradeApiExtendBlockTradeOrder
     */
    readonly blockOrderMatchingKey: string;

    /**
     *
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiExtendBlockTradeOrder
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for newBlockTradeOrder operation in MarketMakerBlockTradeApi.
 * @interface NewBlockTradeOrderRequest
 */
export interface NewBlockTradeOrderRequest {
    /**
     *
     * @type {'MAKER' | 'TAKER'}
     * @memberof MarketMakerBlockTradeApiNewBlockTradeOrder
     */
    readonly liquidity: NewBlockTradeOrderLiquidityEnum;

    /**
     * Max 1 (only single leg supported), list of legs parameters in JSON; example: eapi/v1/block/order/create?orders=[{"symbol":"BTC-210115-35000-C", "price":"100","quantity":"0.0002","side":"BUY","type":"LIMIT"}]
     * @type {Array<NewBlockTradeOrderLegsParameterInner>}
     * @memberof MarketMakerBlockTradeApiNewBlockTradeOrder
     */
    readonly legs: Array<NewBlockTradeOrderLegsParameterInner>;

    /**
     *
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiNewBlockTradeOrder
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for queryBlockTradeDetails operation in MarketMakerBlockTradeApi.
 * @interface QueryBlockTradeDetailsRequest
 */
export interface QueryBlockTradeDetailsRequest {
    /**
     * Block trade matching key.
     * @type {string}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeDetails
     */
    readonly blockOrderMatchingKey: string;

    /**
     * Recv Window.
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeDetails
     */
    readonly recvWindow?: number | bigint;
}

/**
 * Request parameters for queryBlockTradeOrder operation in MarketMakerBlockTradeApi.
 * @interface QueryBlockTradeOrderRequest
 */
export interface QueryBlockTradeOrderRequest {
    /**
     * If specified, returns the specific block trade associated with the blockOrderMatchingKey
     * @type {string}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeOrder
     */
    readonly blockOrderMatchingKey?: string;

    /**
     * End Time, e.g 1593512200000
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeOrder
     */
    readonly endTime?: number | bigint;

    /**
     * Start Time, e.g 1593511200000
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeOrder
     */
    readonly startTime?: number | bigint;

    /**
     * Underlying asset.
     * @type {string}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeOrder
     */
    readonly underlying?: string;

    /**
     * Recv Window.
     * @type {number | bigint}
     * @memberof MarketMakerBlockTradeApiQueryBlockTradeOrder
     */
    readonly recvWindow?: number | bigint;
}

/**
 * MarketMakerBlockTradeApi - object-oriented interface
 * @class MarketMakerBlockTradeApi
 */
export class MarketMakerBlockTradeApi implements MarketMakerBlockTradeApiInterface {
    private readonly configuration: ConfigurationRestAPI;
    private localVarAxiosParamCreator;

    constructor(configuration: ConfigurationRestAPI) {
        this.configuration = configuration;
        this.localVarAxiosParamCreator = MarketMakerBlockTradeApiAxiosParamCreator(configuration);
    }

    /**
     * Accept a block trade order
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Accept Block Trade Order (TRADE)
     * @param {AcceptBlockTradeOrderRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<AcceptBlockTradeOrderResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#accept-block-trade-order Binance API Documentation}
     */
    public async acceptBlockTradeOrder(
        requestParameters: AcceptBlockTradeOrderRequest
    ): Promise<RestApiResponse<AcceptBlockTradeOrderResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.acceptBlockTradeOrder(
            requestParameters?.blockOrderMatchingKey,
            requestParameters?.recvWindow
        );
        return sendRequest<AcceptBlockTradeOrderResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Gets block trades for a specific account.
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Account Block Trade List (USER_DATA)
     * @param {AccountBlockTradeListRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<AccountBlockTradeListResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#account-block-trade-list Binance API Documentation}
     */
    public async accountBlockTradeList(
        requestParameters: AccountBlockTradeListRequest = {}
    ): Promise<RestApiResponse<AccountBlockTradeListResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.accountBlockTradeList(
            requestParameters?.endTime,
            requestParameters?.startTime,
            requestParameters?.underlying,
            requestParameters?.recvWindow
        );
        return sendRequest<AccountBlockTradeListResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Cancel a block trade order.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Cancel Block Trade Order (TRADE)
     * @param {CancelBlockTradeOrderRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<void>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#cancel-block-trade-order Binance API Documentation}
     */
    public async cancelBlockTradeOrder(
        requestParameters: CancelBlockTradeOrderRequest
    ): Promise<RestApiResponse<void>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.cancelBlockTradeOrder(
            requestParameters?.blockOrderMatchingKey,
            requestParameters?.recvWindow
        );
        return sendRequest<void>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Extends a block trade expire time by 30 mins from the current time.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Extend Block Trade Order (TRADE)
     * @param {ExtendBlockTradeOrderRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<ExtendBlockTradeOrderResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#extend-block-trade-order Binance API Documentation}
     */
    public async extendBlockTradeOrder(
        requestParameters: ExtendBlockTradeOrderRequest
    ): Promise<RestApiResponse<ExtendBlockTradeOrderResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.extendBlockTradeOrder(
            requestParameters?.blockOrderMatchingKey,
            requestParameters?.recvWindow
        );
        return sendRequest<ExtendBlockTradeOrderResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Send in a new block trade order.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary New Block Trade Order (TRADE)
     * @param {NewBlockTradeOrderRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<NewBlockTradeOrderResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#new-block-trade-order Binance API Documentation}
     */
    public async newBlockTradeOrder(
        requestParameters: NewBlockTradeOrderRequest
    ): Promise<RestApiResponse<NewBlockTradeOrderResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.newBlockTradeOrder(
            requestParameters?.liquidity,
            requestParameters?.legs,
            requestParameters?.recvWindow
        );
        return sendRequest<NewBlockTradeOrderResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Query block trade details; returns block trade details from counterparty's perspective.
     *
     * Weight(IP): 5
     *
     * Security Type: USER_DATA
     *
     * @summary Query Block Trade Details (USER_DATA)
     * @param {QueryBlockTradeDetailsRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QueryBlockTradeDetailsResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#query-block-trade-details Binance API Documentation}
     */
    public async queryBlockTradeDetails(
        requestParameters: QueryBlockTradeDetailsRequest
    ): Promise<RestApiResponse<QueryBlockTradeDetailsResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.queryBlockTradeDetails(
            requestParameters?.blockOrderMatchingKey,
            requestParameters?.recvWindow
        );
        return sendRequest<QueryBlockTradeDetailsResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }

    /**
     * Check block trade order status.
     *
     * Weight(IP): 5
     *
     * Security Type: TRADE
     *
     * @summary Query Block Trade Order (TRADE)
     * @param {QueryBlockTradeOrderRequest} requestParameters Request parameters.
     * @returns {Promise<RestApiResponse<QueryBlockTradeOrderResponse>>}
     * @throws {RequiredError | ConnectorClientError | UnauthorizedError | ForbiddenError | TooManyRequestsError | RateLimitBanError | ServerError | NotFoundError | NetworkError | BadRequestError}
     * @memberof MarketMakerBlockTradeApi
     * @see {@link https://developers.binance.com/en/docs/catalog/core-trading-derivatives-trading-options/api/rest-api/market-maker-block-trade#query-block-trade-order Binance API Documentation}
     */
    public async queryBlockTradeOrder(
        requestParameters: QueryBlockTradeOrderRequest = {}
    ): Promise<RestApiResponse<QueryBlockTradeOrderResponse>> {
        const localVarAxiosArgs = await this.localVarAxiosParamCreator.queryBlockTradeOrder(
            requestParameters?.blockOrderMatchingKey,
            requestParameters?.endTime,
            requestParameters?.startTime,
            requestParameters?.underlying,
            requestParameters?.recvWindow
        );
        return sendRequest<QueryBlockTradeOrderResponse>(
            this.configuration,
            localVarAxiosArgs.endpoint,
            localVarAxiosArgs.method,
            localVarAxiosArgs.queryParams,
            localVarAxiosArgs.bodyParams,
            localVarAxiosArgs.headerParams,
            localVarAxiosArgs?.timeUnit,
            { isSigned: true }
        );
    }
}

export enum NewBlockTradeOrderLiquidityEnum {
    MAKER = 'MAKER',
    TAKER = 'TAKER',
}
